import axios from "axios";
import { v4 as uuid } from "uuid";
import {
  SAVE_CONSENT_SUCCESS,
  SAVE_CONSENT_REQUEST,
  SAVE_CONSENT_ERROR,
} from "../../shared/constants/action-types";

export const saveConsentRequest = (options) => ({
  type: SAVE_CONSENT_REQUEST,
  payload: options,
});

export const saveConsentSuccess = (content) => ({
  type: SAVE_CONSENT_SUCCESS,
  payload: content,
});

export const saveConsentError = (err) => ({
  type: SAVE_CONSENT_ERROR,
  payload: err,
});

const getConsentError = (err) => {
  const { status, data } = err.response || {};

  if (status === 401 && data?.message) {
    return {
      status,
      errorCode: data.errorCode,
      message: data.message,
    };
  }

  return err.toString();
};

export const saveConsent = (options) => (dispatch, getState) => {
  const { api } = getState().paths;
  const { userId, isConsented, token } = {
    ...options,
  };
  const url = `${api}/v2/consent/responses`;
  dispatch(saveConsentRequest(options));
  const body = {
    correlationId: uuid(),
    status: isConsented ? "ACCEPTED" : "DECLINED",
    sessionId: uuid(),
    userId: userId,
  };

  return axios.post(url, body, { headers: { "x-consent-token": token } }).then(
    (res) => {
      dispatch(saveConsentSuccess({ data: res.data, accepted: isConsented }));
    },
    (err) => {
      dispatch(saveConsentError(getConsentError(err)));
    },
  );
};
